import { z } from 'zod';

/**
 * The glance-map schema (ADR-002 §3, §3.3; glance-grammar-spec §1.1).
 *
 * Exactly three slots — one primary fact, one delta/trend, one state color. The
 * VALUES here are metric-key *names* (which normalized field feeds each slot);
 * they are validated against the tile type's `dataShape` in the tile refinement
 * (a name must reference a real metric — ADR-002 §3.3). `delta`/`state` may be
 * null (the slot is unused), but `primary` is always required — every tile has
 * one big fact (glance-grammar-spec §1.2: primary is Required at every size).
 */
export const glanceMapSchema = z
  .object({
    /** Metric key for the one big fact. Required for every tile. */
    primary: z.string().min(1),
    /** Metric key for the trend line, or null if the tile has no delta. */
    delta: z.string().min(1).nullable(),
    /** Metric key that maps to a state color, or null for a neutral tile. */
    state: z.string().min(1).nullable(),
  })
  .strict();

export type GlanceMap = z.infer<typeof glanceMapSchema>;
